/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, convertHexToRGB, replacePXinStringWithEM, color, textShadow } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FIELD : SELECT : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	select: {
		backgroundColor: 'transparent',
		border: 'none',
		color: 'inherit',
		fontSize: 'inherit',
		width: '100%',
		height: '100%',
		outline: 'none',
        '&.isValid-true':{
            fontWeight: 'bold',
            color:color.white
        },
        '&.macos-false': {
			'& option': {
                backgroundColor: '#333333'
            }
		}
	}
};
